import moment from 'moment-timezone';
import md5 from 'crypto-js/md5';
import config from '../../config';
import authenticationService from '../services/authentication/AuthenticationService';

export const LOGO_UPDATED_LOCAL_STORAGE_KEY = 'key_logoUpdated';
export const DISPLAY_REGISTRATION_HELP_LOCAL_STORAGE_KEY = 'displayOrganisationRegistrationHelp';

export const getOrganisationLogoUrl = organisationId => {
  let postFix = '';
  let itemLogoUpdated = localStorage.getItem(LOGO_UPDATED_LOCAL_STORAGE_KEY);
  if (itemLogoUpdated) {
    itemLogoUpdated = JSON.parse(itemLogoUpdated);
    if (itemLogoUpdated[organisationId] && moment()
      .isBefore(moment(itemLogoUpdated[organisationId]).add(5, 'm'))) {
      // If the logo has been recently updated (less than 5 minutes ago)
      // then we use a postFix to manually retrieve the new logo
      postFix += `?version=${Math.random().toString(36).substring(7)}`;
    } else if (itemLogoUpdated[organisationId]) {
      delete itemLogoUpdated[organisationId];
      localStorage.setItem(LOGO_UPDATED_LOCAL_STORAGE_KEY, JSON.stringify(itemLogoUpdated));
    }
  }

  return `${config.logoUrl}${md5(String(organisationId)).toString()}_medium_file.jpg${postFix}`;
};

/**
 * Business rules to display landing page for a new user
 * @param {*} organisations current organisations tied to users
 * @returns true is not a BO user, not tied to orga, and without a session that already displayed the view
 */
export const displayOrganisationRegistrationHelp = organisations => {
  const isBackOffice = authenticationService.roles().isBackOffice();
  const hasAlreadyBeenDisplayed = localStorage.getItem(DISPLAY_REGISTRATION_HELP_LOCAL_STORAGE_KEY) === 'true';
  return (organisations?.length === 0) && !isBackOffice && !hasAlreadyBeenDisplayed;
};

const organisation = {
  getOrganisationLogoUrl,
  displayOrganisationRegistrationHelp
};

export default organisation;
